import { render, staticRenderFns } from "./TearLensCalcDialog.vue?vue&type=template&id=ae038562&scoped=true&"
import script from "./TearLensCalcDialog.vue?vue&type=script&lang=js&"
export * from "./TearLensCalcDialog.vue?vue&type=script&lang=js&"
import style0 from "./TearLensCalcDialog.vue?vue&type=style&index=0&id=ae038562&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae038562",
  null
  
)

export default component.exports